import type { ServerResponse } from "@/http"
import type { IPresetThemeResponse } from "@/models/presetTheme"
import { useQuery } from "@tanstack/vue-query"
import { axios } from "@/axios"
import { PresetTheme } from "@/models/presetTheme"

export async function listPresetThemes() {
  const endpoint = `api/system/presets`

  const response = await axios.get<ServerResponse<IPresetThemeResponse[]>>(endpoint)

  return response.data.Data?.map(theme => PresetTheme.fromResponse(theme)) ?? []
}

const PRESET_THEMES_QUERY_KEY = "listPresetThemes"

export function useListPresetThemes() {
  return useQuery({
    queryKey: [PRESET_THEMES_QUERY_KEY],
    queryFn: () => listPresetThemes(),
  })
}
